// Generated from localization/strings.csv by `python3 scripts/strings.py import`: edit the CSV, not this file.
// German for every key the web app uses (the keys are the English text, as in the apps' catalogs), and the
// English plural forms. test/app/i18n.test.ts fails while a key used in src/app has no German here.

export type Entry = string | { zero?: string; one?: string; other: string };

/** English keys whose text depends on `count`. */
export const EN_PLURALS: Record<string, Entry> = {
  "Deadline in {count} days": { one: "Deadline in {count} day", other: "Deadline in {count} days" },
  "Deadline {count} days ago": { one: "Deadline {count} day ago", other: "Deadline {count} days ago" },
  "Every {count} days": { one: "Every day", other: "Every {count} days" },
  "Every {count} months": { one: "Every month", other: "Every {count} months" },
  "Every {count} months on {place}": { one: "Every month on {place}", other: "Every {count} months on {place}" },
  "Every {count} weeks": { one: "Every week", other: "Every {count} weeks" },
  "Every {count} years": { one: "Every year", other: "Every {count} years" },
  "In Today for {count} days": { one: "In Today for {count} day", other: "In Today for {count} days" },
  "Show {count} Completed": { one: "Show {count} Completed", other: "Show {count} Completed" },
  "Show {count} More": { one: "Show {count} More", other: "Show {count} More" },
  "Stale, added {count} days ago": { one: "Stale, added {count} day ago", other: "Stale, added {count} days ago" },
  "{count} Days": { one: "{count} Day", other: "{count} Days" },
  "{count} older to-dos are kept. Pro shows your whole history.": { one: "{count} older to-do is kept. Pro shows your whole history.", other: "{count} older to-dos are kept. Pro shows your whole history." },
  "{count} starting later": { one: "{count} starting later", other: "{count} starting later" },
  "{count} steps": { one: "{count} step", other: "{count} steps" },
  "{count} to-dos added to {list}": { one: "{count} to-do added to {list}", other: "{count} to-dos added to {list}" },
  "{count} to-dos deleted": { one: "{count} to-do deleted", other: "{count} to-dos deleted" },
};

/** English keys whose English the CSV writes differently (a key stays as the code has it). */
export const EN: Record<string, string> = {
  "Done so far": "Done",
  "Due": "Deadlines",
  "Move over what is left": "Move through what is left",
  "Yearly On": "On",
};

export const DE: Record<string, Entry> = {
  "1st": "1.",
  "2nd": "2.",
  "3rd": "3.",
  "4th": "4.",
  "A Day Earlier": "Einen Tag früher",
  "A day earlier": "Einen Tag früher",
  "A Day Later": "Einen Tag später",
  "A day later": "Einen Tag später",
  "A habit is a to-do you mean to do again and again. Make one here, or with the flame in any to-do.": "Eine Gewohnheit ist ein To-Do, das du immer wieder tun willst. Leg hier eine an oder mit der Flamme in einem To-Do.",
  "A Month": "Einen Monat",
  "A month of it, as you planned it.": "Ein ganzer Monat, wie du es geplant hast.",
  "A newer version of Todolix shows everything in your account.": "Eine neuere Version von Todolix zeigt alles in deinem Konto.",
  "A project has an end; a list goes on.": "Ein Projekt hat ein Ende, eine Liste geht weiter.",
  "A season of it, as you planned it.": "Eine ganze Jahreszeit, wie du es geplant hast.",
  "A shared area: you can add, change and complete its to-dos.": "Ein geteilter Bereich: Du kannst To-Dos hinzufügen, ändern und erledigen.",
  "A shared list: you can add, change and complete its to-dos.": "Eine geteilte Liste: Du kannst To-Dos hinzufügen, ändern und erledigen.",
  "A short, soft sound as you tick off a to-do.": "Ein kurzer, leiser Ton, wenn du ein To-Do erledigst.",
  "A ticked item moves below the open ones. Opened again, it goes back to its place.": "Ein abgehakter Punkt rückt unter die offenen. Wieder geöffnet, kehrt er an seinen Platz zurück.",
  "A Week": "Eine Woche",
  "A Week Earlier": "Eine Woche früher",
  "A week earlier or later": "Eine Woche früher oder später",
  "A Week Later": "Eine Woche später",
  "A week that falls short once keeps the streak; two in a row end it.": "Eine Woche, die einmal zu kurz kommt, hält die Serie; zwei in Folge beenden sie.",
  "A whole week of it, as you planned it.": "Eine ganze Woche, wie du es geplant hast.",
  "A whole year of it, as you planned it.": "Ein ganzes Jahr, wie du es geplant hast.",
  "Account": "Konto",
  "Add Item": "Punkt hinzufügen",
  "Add to Favorites": "Zu Favoriten hinzufügen",
  "Add to the selection": "Zur Auswahl hinzufügen",
  "Add To-Do": "To-Do hinzufügen",
  "Add To-Do on {day}": "To-Do für {day} hinzufügen",
  "Add To-Do to {name}": "To-Do zu {name} hinzufügen",
  "Add “{name}”": "„{name}“ hinzufügen",
  "Added to {list}": "Zu {list} hinzugefügt",
  "Afternoon": "Nachmittags",
  "All": "Alle",
  "All Done": "Alles erledigt",
  "All of {name}": "Alles aus {name}",
  "All Templates": "Alle Vorlagen",
  "Also moves it to Today": "Kommt damit auch nach „Heute“",
  "An area or project gets its own address from its menu: Email Address.": "Ein Bereich oder Projekt bekommt seine eigene Adresse über sein Menü: E-Mail-Adresse.",
  "An invitation to “{title}”": "Eine Einladung zu „{title}“",
  "Anytime": "Jederzeit",
  "Archive": "Archiv",
  "Area": "Bereich",
  "Areas and Projects": "Bereiche und Projekte",
  "Ask about your day, or say what to change.": "Frag nach deinem Tag oder sag, was sich ändern soll.",
  "Assistant": "Assistent",
  "Back to Sign In": "Zurück zur Anmeldung",
  "Back to the list": "Zurück zur Liste",
  "Back to Today": "Doch heute",
  "best so far": "bisher am besten",
  "Best so far: {best}": "Bisher am besten: {best}",
  "Best streak, {count} days in a row": "Beste Serie, {count} Tage in Folge",
  "Best streak, {count} months in a row": "Beste Serie, {count} Monate in Folge",
  "Best streak, {count} weeks in a row": "Beste Serie, {count} Wochen in Folge",
  "Between the chips": "Zwischen den Chips",
  "Birthday": "Geburtstag",
  "Birthday of {name}": "Geburtstag von {name}",
  "Board": "Board",
  "Browser": "Browser",
  "Cancel": "Abbrechen",
  "Celebrate Milestones": "Meilensteine feiern",
  "Change": "Ändern",
  "Change How Often?": "Wie oft ändern?",
  "Change Icon": "Symbol ändern",
  "Checklist": "Checkliste",
  "Checklist Item": "Checklistenpunkt",
  "Checklists": "Checklisten",
  "Choose Icon": "Symbol wählen",
  "Choose which lists Home shows, so it holds just what you use.": "Wähle, welche Listen Home zeigt, damit dort nur steht, was du nutzt.",
  "Click": "Klick",
  "Click a day to change it": "Klick auf einen Tag, um ihn zu ändern",
  "Click anywhere": "Klicke irgendwo",
  "Close the picker, then the to-do": "Die Auswahl schließen, dann das To-Do",
  "Close, or clear the selection": "Schließen oder Auswahl aufheben",
  "Collapse": "Verkleinern",
  "Collapse {name}": "{name} zuklappen",
  "Coming to the Web": "Kommt ins Web",
  "Complete": "Erledigen",
  "Complete today": "Heute erledigen",
  "Completed": "Erledigt",
  "Completed by {name}, {when}": "Erledigt von {name}, {when}",
  "Completed to-dos show up here, by the day you did them.": "Erledigte To-Dos erscheinen hier, nach dem Tag, an dem du sie erledigt hast.",
  "Completing To-Dos": "To-Dos erledigen",
  "Confirm your email address first: there is a mail from Todolix in your inbox.": "Bestätige zuerst deine E-Mail-Adresse: In deinem Postfach liegt eine Mail von Todolix.",
  "Continue with Apple": "Weiter mit Apple",
  "Continue with Google": "Weiter mit Google",
  "Convert to Project": "In Projekt umwandeln",
  "Copied": "Kopiert",
  "Copy": "Kopieren",
  "Copy Address": "Adresse kopieren",
  "Count From Completion": "Ab Erledigung zählen",
  "Count It": "Eintragen",
  "Count “{title}” as done anyway?": "„{title}“ trotzdem als erledigt eintragen?",
  "Counted for yesterday": "Für gestern gezählt",
  "Create": "Erstellen",
  "Create Account": "Konto erstellen",
  "Create Address": "Adresse erstellen",
  "Create Project": "Projekt erstellen",
  "Daily": "Täglich",
  "Data": "Daten",
  "Day": "Tag",
  "day": "Tag",
  "Day of the Month": "Tag des Monats",
  "Days": "Wochentage",
  "days in a row": "Tage in Folge",
  "days in {month}": "Tage im {month}",
  "Days of the Month": "Tage im Monat",
  "Deadline": "Deadline",
  "Deadline in {count} days": { one: "Deadline in {count} Tag", other: "Deadline in {count} Tagen" },
  "Deadline today": "Deadline heute",
  "Deadline tomorrow": "Deadline morgen",
  "Deadline {count} days ago": { one: "Deadline vor {count} Tag", other: "Deadline vor {count} Tagen" },
  "Deadlines": "Deadlines",
  "Deadlines First": "Deadlines zuerst",
  "Decline": "Ablehnen",
  "DELETE": "LÖSCHEN",
  "Delete": "Löschen",
  "Delete Account": "Konto löschen",
  "Delete Account?": "Konto löschen?",
  "Delete All Data": "Alle Daten löschen",
  "Delete All Data?": "Alle Daten löschen?",
  "Delete Habit": "Gewohnheit löschen",
  "Delete Section": "Abschnitt löschen",
  "Delete Section?": "Abschnitt löschen?",
  "Delete To-Do": "To-Do löschen",
  "Delete {name}": "{name} löschen",
  "Delete “{name}”?": "„{name}“ löschen?",
  "Done": "Fertig",
  "Done Items at the End": "Erledigte Punkte ans Ende",
  "Done so far": "Erledigt",
  "Don’t Change": "Nicht ändern",
  "Drag a to-do here to plan it.": "Zieh ein To-Do hierher, um es einzuplanen.",
  "Due": "Deadlines",
  "Due Today": "Heute fällig",
  "Each goes straight to its area or project.": "Jede geht direkt in ihren Bereich oder ihr Projekt.",
  "Earlier": "Früher",
  "Edit Notes": "Notizen bearbeiten",
  "Email": "E-Mail",
  "Email Address…": "E-Mail-Adresse …",
  "Email to Inbox": "E-Mail an die Inbox",
  "Email to Todolix": "E-Mail an Todolix",
  "Email to {name}": "E-Mail an {name}",
  "Empty": "Leer",
  "End of Month": "Monatsende",
  "Ends": "Endet",
  "Ends On": "Endet am",
  "Enter your email and password.": "Gib deine E-Mail-Adresse und dein Passwort ein.",
  "Evening": "Abends",
  "Every": "Alle",
  "Every day": "Jeden Tag",
  "Every how many days": "Alle wie viele Tage",
  "Every to-do, project, area and section goes, on all your devices. Your account stays.": "Alle To-Dos, Projekte, Bereiche und Abschnitte werden gelöscht, auf all deinen Geräten. Dein Konto bleibt.",
  "Every weekday": "Jeden Werktag (Mo–Fr)",
  "Every {count} days": { one: "Jeden Tag", other: "Alle {count} Tage" },
  "Every {count} months": { one: "Jeden Monat", other: "Alle {count} Monate" },
  "Every {count} months on {place}": { one: "Jeden Monat am {place}", other: "Alle {count} Monate am {place}" },
  "Every {count} weeks": { one: "Jede Woche", other: "Alle {count} Wochen" },
  "Every {count} years": { one: "Jedes Jahr", other: "Alle {count} Jahre" },
  "Every {days}": "Jeden {days}",
  "Every {ordinal} {what} of the month": "Jeden {ordinal} {what} im Monat",
  "Everyone in it can add, change and complete its to-dos. Its name, sections and place are the owner's.": "Alle darin können To-Dos hinzufügen, ändern und erledigen. Name, Abschnitte und Platz bestimmt, wer es teilt.",
  "Everything": "Alles",
  "Everything has found its place.": "Alles hat seinen Platz gefunden.",
  "Everything is planned. Drag a to-do here to take it out of the plan.": "Alles ist eingeplant. Zieh ein To-Do hierher, um es wieder aus dem Plan zu nehmen.",
  "Everything you have done, beyond the last 30 days. It is all kept; Pro shows it.": "Alles, was du erledigt hast, auch vor mehr als 30 Tagen. Gespeichert bleibt alles; Pro zeigt es.",
  "Expand": "Vergrößern",
  "Expand {name}": "{name} aufklappen",
  "Favorites": "Favoriten",
  "Fewer": "Weniger",
  "Filter": "Filtern",
  "Filter Unscheduled": "„Ungeplant“ filtern",
  "Find": "Suchen",
  "Find a Project or Area": "Projekt oder Bereich suchen",
  "Find an Area": "Bereich suchen",
  "Find or Add a Tag": "Tag suchen oder hinzufügen",
  "Find to-dos, projects, tags": "To-Dos, Projekte, Tags suchen",
  "first": "ersten",
  "For a holiday or an illness: nothing is due, and the streak waits.": "Für Urlaub oder Krankheit: Nichts ist dran, und die Serie wartet.",
  "Forgot Password?": "Passwort vergessen?",
  "fourth": "vierten",
  "From the title to the chips, then between them": "Vom Titel zu den Chips, dann zwischen ihnen",
  "Future Ones": "Künftige",
  "Get Pro in the Todolix app on your iPhone, iPad or Mac.": "Hol dir Pro in der Todolix-App auf deinem iPhone, iPad oder Mac.",
  "Get Pro in the Todolix app on your iPhone, iPad or Mac. It works here as soon as it's on, with the same account.": "Hol dir Pro in der Todolix-App auf deinem iPhone, iPad oder Mac. Sobald es aktiv ist, gilt es auch hier, mit demselben Konto.",
  "Give a to-do a day and it waits here until then.": "Gib einem To-Do ein Datum, und es wartet hier bis dahin.",
  "Habit": "Gewohnheit",
  "Habit added": "Gewohnheit hinzugefügt",
  "Habit deleted": "Gewohnheit gelöscht",
  "Habit paused": "Gewohnheit pausiert",
  "Habit resumed": "Gewohnheit fortgesetzt",
  "Habit: make it a to-do again": "Gewohnheit: wieder zum To-Do machen",
  "Habits": "Gewohnheiten",
  "Habits in Today": "Gewohnheiten in Heute",
  "Habits Settings…": "Einstellungen für Gewohnheiten…",
  "Habits Today": "Gewohnheiten heute",
  "Half a year of it, as you planned it.": "Ein halbes Jahr, wie du es geplant hast.",
  "Height of Unscheduled": "Höhe von „Ungeplant“",
  "Hide Completed": "Erledigte ausblenden",
  "Hide Overview": "Überblick ausblenden",
  "Hide Unscheduled": "„Ungeplant“ ausblenden",
  "Home": "Home",
  "Home Your Way": "Home nach deinem Geschmack",
  "How Often": "Wie oft",
  "Ideas you don't want to lose go here.": "Ideen, die du nicht verlieren willst, gehören hierher.",
  "If the address got around, a new one replaces it. The old one stops working at once.": "Wenn die Adresse die Runde gemacht hat, ersetzt eine neue sie. Die alte funktioniert dann sofort nicht mehr.",
  "If there's an account for {email}, a mail to set a new password is on its way.": "Wenn es ein Konto für {email} gibt, ist eine E-Mail zum Festlegen eines neuen Passworts unterwegs.",
  "In a Picker": "In einer Auswahl",
  "In a row, as you planned it. Keep it going.": "In Folge, wie du es geplant hast. Bleib dran.",
  "In a Week": "In einer Woche",
  "In an Open To-Do": "In einem offenen To-Do",
  "In Their Own Group": "In eigener Gruppe",
  "In Today": "In „Heute“",
  "In Today for {count} days": { one: "Seit {count} Tag in Heute", other: "Seit {count} Tagen in Heute" },
  "Inbox": "Inbox",
  "Inbox Zero": "Inbox leer",
  "Inbox, Today and Deadlines always stay at the top of Home. Lists left off Home are always in Find.": "„Inbox“, „Heute“ und „Deadlines“ stehen immer oben auf Home. Listen, die nicht auf Home stehen, findest du immer über „Suchen“.",
  "Into Unscheduled's filter": "In den Filter von „Ungeplant“",
  "Invite people, or stop sharing, in the Todolix app on your iPhone, iPad or Mac.": "Personen einladen oder das Teilen beenden kannst du in der Todolix-App auf deinem iPhone, iPad oder Mac.",
  "It goes from your Todolix. The owner keeps it.": "Es verschwindet aus deinem Todolix. Wer es teilt, behält es.",
  "It goes off on your iPhone, iPad, Mac and Watch.": "Sie meldet sich auf deinem iPhone, iPad, Mac und deiner Watch.",
  "It is kept, and this version works as usual.": "Es bleibt erhalten, und diese Version funktioniert wie gewohnt.",
  "It stays as a to-do and leaves Habits. You can take this back with Undo right after; made a habit again later, its history comes back, and the days you ticked meanwhile count too.": "Es bleibt als To-Do und verschwindet aus den Gewohnheiten. Direkt danach kannst du das mit „Widerrufen“ zurücknehmen; machst du es später wieder zur Gewohnheit, kommt sein Verlauf zurück, und die Tage, an denen du es inzwischen abgehakt hast, zählen mit.",
  "Item": "Punkt",
  "Its streak and every day you ticked are deleted on all your devices. You can take this back with Undo right after; later, it can’t be restored.": "Die Serie und jeder abgehakte Tag werden auf all deinen Geräten gelöscht. Direkt danach kannst du das mit „Widerrufen“ zurücknehmen; später lässt es sich nicht wiederherstellen.",
  "Its to-dos stay in the list, outside any section.": "Seine To-Dos bleiben in der Liste, ohne Abschnitt.",
  "Join": "Beitreten",
  "Join “{name}”": "„{name}“ beitreten",
  "Keep": "Behalten",
  "Keep as Text": "Als Text behalten",
  "Keep “{words}” as Text": "„{words}“ als Text behalten",
  "Keyboard Shortcuts": "Tastenkürzel",
  "Keys in the browser. ⌘N, ⌘T and ⌘F stay the browser's.": "Tasten im Browser. ⌘N, ⌘T und ⌘F bleiben beim Browser.",
  "Kind": "Art",
  "Language": "Sprache",
  "Last": "Letzter",
  "last": "letzten",
  "Last Day": "Letzter Tag",
  "last used {date}": "zuletzt am {date}",
  "Later": "Später",
  "Learn More": "Mehr erfahren",
  "Leave": "Verlassen",
  "Leave “{name}”?": "„{name}“ verlassen?",
  "Leave…": "Verlassen …",
  "Legal Notice": "Impressum",
  "Less Often": "Seltener",
  "List": "Liste",
  "Lists": "Listen",
  "Loading your to-dos…": "Deine To-Dos werden geladen …",
  "Made a habit": "Zur Gewohnheit gemacht",
  "Made a to-do": "Zum To-Do gemacht",
  "Mail sent here arrives as a to-do in your Inbox.": "E-Mails an diese Adresse kommen als To-Do in deiner Inbox an.",
  "Mail to the old address will no longer arrive.": "Mails an die alte Adresse kommen nicht mehr an.",
  "Mail to this address becomes a to-do in your Inbox: the subject is the title, the text the notes. Forward mails to it, or save it as a contact.": "Eine Mail an diese Adresse wird ein To-Do in deiner Inbox: Der Betreff wird der Titel, der Text die Notizen. Leite Mails dorthin weiter oder sichere die Adresse als Kontakt.",
  "Mail to this address becomes a to-do in {name}. Renaming or moving it does not change the address. If it is ever completed or deleted, mail goes to the Inbox instead.": "Eine Mail an diese Adresse wird ein To-Do in {name}. Umbenennen oder Verschieben ändert die Adresse nicht. Ist das Ziel einmal erledigt oder gelöscht, kommt die Mail stattdessen in die Inbox.",
  "Make a To-Do": "Zum To-Do machen",
  "Make an area in the app first.": "Leg zuerst in der App einen Bereich an.",
  "Make It a Habit": "Zur Gewohnheit machen",
  "Make “{name}” a To-Do?": "„{name}“ zum To-Do machen?",
  "Mark as Done": "Als erledigt markieren",
  "Mark as Not Done": "Als nicht erledigt markieren",
  "Miscellaneous": "Sonstiges",
  "Missed": "Verpasst",
  "Missed once, kept": "Einmal verpasst, gehalten",
  "Missed Yesterday": "Gestern verpasst",
  "missed yesterday": "gestern verpasst",
  "Missing once keeps the streak; two in a row end it.": "Einmal verpasst hält die Serie; zwei in Folge beenden sie.",
  "Month": "Monat",
  "Month done": "Monat geschafft",
  "Monthly": "Monatlich",
  "Monthly On": "Monatlich am",
  "Monthly on {days}": "Monatlich am {days}",
  "Months": "Monate",
  "months in a row": "Monate in Folge",
  "More": "Mehr",
  "More Often": "Öfter",
  "Morning": "Morgens",
  "Move": "Verschieben",
  "Move a checklist item": "Einen Checklistenpunkt verschieben",
  "Move over what is left": "Durch die übrigen Einträge gehen",
  "Move to Anytime": "Nach Jederzeit verschieben",
  "Move to Inbox": "In die Inbox verschieben",
  "Move to Miscellaneous": "Nach Sonstiges verschieben",
  "Move to Someday": "Nach Irgendwann verschieben",
  "Move to {name}": "Nach {name} verschieben",
  "Moved": "Verschoben",
  "Moved from {day}": "Verschoben vom {day}",
  "Moving About": "Navigieren",
  "Name": "Name",
  "Narrow the Archive to a project or area": "Das Archiv auf ein Projekt oder einen Bereich eingrenzen",
  "Narrow the choices, or a day or time: tom, fri, 12.10., 9": "Die Auswahl eingrenzen oder ein Datum oder eine Uhrzeit eingeben: mor, fr, 12.10., 9",
  "Never": "Nie",
  "Never Miss Twice": "Nie zweimal auslassen",
  "never miss twice": "nie zweimal auslassen",
  "Never Miss Twice for New Habits": "Nie zweimal auslassen für neue Gewohnheiten",
  "New Address": "Neue Adresse",
  "New Habit": "Neue Gewohnheit",
  "New List": "Neue Liste",
  "New Project": "Neues Projekt",
  "New Section": "Neuer Abschnitt",
  "New Step": "Neuer Schritt",
  "New Template": "Neue Vorlage",
  "New To-Do": "Neues To-Do",
  "New to-do": "Neues To-Do",
  "New to-do on the chosen day": "Neues To-Do am gewählten Tag",
  "Next Groups": "Nächste Gruppen",
  "Next Month": "Nächster Monat",
  "Next Week": "Nächste Woche",
  "Next: {day}": "Nächstes Mal: {day}",
  "No address yet": "Noch keine Adresse",
  "No Area": "Kein Bereich",
  "No deadlines": "Keine Deadlines",
  "No emoji found.": "Kein Emoji gefunden.",
  "No habits yet": "Noch keine Gewohnheiten",
  "No Section": "Kein Abschnitt",
  "No tags yet. Type one to add it.": "Noch keine Tags. Tipp einen ein, um ihn hinzuzufügen.",
  "Noon": "Mittags",
  "Not in a section": "Ohne Abschnitt",
  "Not Now": "Nicht jetzt",
  "Not Planned": "Nicht geplant",
  "Not Planned Today": "Heute nicht geplant",
  "Not planned today": "Heute nicht geplant",
  "Not Synced Since {time}": "Seit {time} nicht synchronisiert",
  "Not synced since {time}": "Seit {time} nicht synchronisiert",
  "Not Today": "Heute nicht",
  "Not today": "Heute nicht",
  "Notes": "Notizen",
  "Nothing done yet": "Noch nichts erledigt",
  "Nothing for someday": "Nichts für irgendwann",
  "Nothing for today": "Nichts für heute",
  "Nothing found": "Nichts gefunden",
  "Nothing here": "Hier ist nichts",
  "Nothing matches.": "Nichts passt.",
  "Nothing planned for today": "Für heute ist nichts geplant",
  "Nothing scheduled": "Nichts geplant",
  "Nothing stale": "Nichts liegengeblieben",
  "Nothing waits in {list}.": "In {list} wartet nichts.",
  "Now": "Jetzt",
  "of {count}": "von {count}",
  "of {total}": "von {total}",
  "Offline Since {time}": "Seit {time} offline",
  "Offline since {time}": "Seit {time} offline",
  "Often Used": "Oft verwendet",
  "OK": "OK",
  "On a Day": "An einem Datum",
  "On a Weekday": "An einem Wochentag",
  "On Any Days": "An beliebigen Tagen",
  "On Day {day}": "Am {day}.",
  "On Days": "An Tagen",
  "On Home": "Auf Home",
  "On the {ordinal} {what}": "Am {ordinal} {what}",
  "On These Days": "An diesen Tagen",
  "On, with this account.": "Aktiv, mit diesem Konto.",
  "Once a month": "Einmal im Monat",
  "Once a week": "Einmal pro Woche",
  "One address for everything, into the Inbox.": "Eine Adresse für alles, in die Inbox.",
  "Only the owner can do that.": "Das kann nur, wer es teilt.",
  "Open": "Öffnen",
  "Open Deadlines": "Deadlines öffnen",
  "Open the chip's picker": "Die Auswahl des Chips öffnen",
  "Open the Inbox": "Inbox öffnen",
  "Open to-dos without a date or deadline that were added this long ago. They turn brown in lists and gather in Stale.": "Offene To-Dos ohne Datum oder Deadline, die vor so langer Zeit hinzugekommen sind. Sie werden in Listen braun und sammeln sich unter „Liegengeblieben“.",
  "or": "oder",
  "Over three months of it, as you planned it.": "Über drei Monate, wie du es geplant hast.",
  "Overdue": "Überfällig",
  "Overview": "Überblick",
  "Owner": "Teilt es",
  "Page Through the Week": "Durch die Woche blättern",
  "Part of Todolix Pro": "Teil von Todolix Pro",
  "Password": "Passwort",
  "Pause": "Pausieren",
  "Pause Habit": "Gewohnheit pausieren",
  "Paused": "Pausiert",
  "Paused until {day}": "Pausiert bis {day}",
  "Pause…": "Pausieren …",
  "People": "Personen",
  "People…": "Personen …",
  "Pick a Day": "Datum wählen",
  "Pin the projects and lists you use most to the top of Home.": "Heft die Projekte und Listen, die du am meisten nutzt, oben auf Home an.",
  "Plan": "Planen",
  "Planned": "Geplant",
  "Press Q to add a to-do, or drag one here.": "Drück Q für ein neues To-Do oder zieh eines hierher.",
  "Press Q to add a to-do.": "Drück Q für ein neues To-Do.",
  "Previous Groups": "Vorige Gruppen",
  "Previous Month": "Vorheriger Monat",
  "Previous or next to-do": "Vorheriges oder nächstes To-Do",
  "Privacy Policy": "Datenschutzerklärung",
  "Project": "Projekt",
  "Projects": "Projekte",
  "Put It In": "Ablegen in",
  "Redo": "Wiederholen",
  "Redone": "Wiederholt",
  "Reload": "Neu laden",
  "Reminder": "Erinnerung",
  "Reminder removed": "Erinnerung entfernt",
  "Remove Address": "Adresse entfernen",
  "Remove Deadline": "Deadline entfernen",
  "Remove from Favorites": "Aus Favoriten entfernen",
  "Remove Reminder": "Erinnerung entfernen",
  "Rename": "Umbenennen",
  "Repeat": "Wiederholen",
  "Replace this address?": "Diese Adresse ersetzen?",
  "Rests without Pro": "Ruht ohne Pro",
  "Results": "Ergebnisse",
  "Resume": "Fortsetzen",
  "Save and close": "Sichern und schließen",
  "Schedule": "Planen",
  "Schedule for Today": "Für heute planen",
  "Schedule for Tomorrow": "Für morgen planen",
  "Scheduled": "Geplant",
  "Scheduled as a week, or as a list": "„Geplant“ als Woche oder als Liste",
  "Scheduled for Today": "Für heute geplant",
  "Scheduled for {day}": "Geplant für {day}",
  "Search Emoji": "Emoji suchen",
  "second": "zweiten",
  "Section Name": "Name des Abschnitts",
  "Sections": "Abschnitte",
  "Select a range": "Bereich auswählen",
  "Select all": "Alles auswählen",
  "Select more": "Mehr auswählen",
  "Send Link": "Link senden",
  "Send or forward mail to your own addresses, and it arrives as a to-do in the Inbox, an area or a project.": "Schick E-Mails an deine eigenen Adressen oder leite sie dorthin weiter, und sie kommen als To-Do in der Inbox, einem Bereich oder einem Projekt an.",
  "Set": "Eingestellt",
  "Set in a newer version": "In einer neueren Version eingestellt",
  "Settings": "Einstellungen",
  "Shared with {names}": "Geteilt mit {names}",
  "Shared “{name}”": "Geteilt: „{name}“",
  "Shared, waiting for others to join": "Geteilt, wartet auf andere",
  "Sharing is part of Todolix Pro.": "Teilen gehört zu Todolix Pro.",
  "Short": "Zu kurz",
  "Short, kept": "Zu kurz, gehalten",
  "Show": "Anzeigen",
  "Show as Board": "Als Board zeigen",
  "Show as List": "Als Liste zeigen",
  "Show Details": "Details zeigen",
  "Show Empty Sections": "Leere Abschnitte zeigen",
  "Show everything again": "Wieder alles anzeigen",
  "Show Home": "Home zeigen",
  "Show or Hide Home": "Home ein- oder ausblenden",
  "Show or hide Home": "Home ein- oder ausblenden",
  "Show or hide the overview beside the list": "Überblick neben der Liste zeigen oder ausblenden",
  "Show or hide Unscheduled": "„Ungeplant“ ein- oder ausblenden",
  "Show Overview": "Überblick zeigen",
  "Show Scheduled As": "„Geplant“ zeigen als",
  "Show Streaks": "Serien zeigen",
  "Show Unscheduled": "„Ungeplant“ zeigen",
  "Show {count} Completed": { one: "{count} erledigtes zeigen", other: "{count} erledigte zeigen" },
  "Show {count} More": { one: "{count} weiteres zeigen", other: "{count} weitere zeigen" },
  "Sign In": "Anmelden",
  "Sign Out": "Abmelden",
  "Signed in with Apple": "Mit Apple angemeldet",
  "Signed in with email": "Mit E-Mail angemeldet",
  "Signed in with Google": "Mit Google angemeldet",
  "Since {month}": "Seit {month}",
  "Situations": "Situationen",
  "Skip This Time": "Diesmal überspringen",
  "Someday": "Irgendwann",
  "Something in your account was made with a newer version. It is kept, and this version works as usual; a newer one shows everything.": "Etwas in deinem Konto wurde mit einer neueren Version angelegt. Es bleibt erhalten, und diese Version funktioniert wie gewohnt; eine neuere zeigt alles.",
  "Sound Effect by José Mejía from Pixabay": "Soundeffekt von José Mejía auf Pixabay",
  "Sound Effect by SoundShelfStudio from Pixabay": "Soundeffekt von SoundShelfStudio auf Pixabay",
  "Sound When Completing": "Ton beim Erledigen",
  "Stale": "Liegengeblieben",
  "Stale After": "Liegengeblieben nach",
  "Stale, added {count} days ago": { one: "Liegengeblieben, vor {count} Tag hinzugefügt", other: "Liegengeblieben, vor {count} Tagen hinzugefügt" },
  "Starts": "Beginnt",
  "Steps": "Schritte",
  "Steps are written and changed in the Todolix app on your iPhone, iPad or Mac.": "Schritte schreibst und änderst du in der Todolix-App auf deinem iPhone, iPad oder Mac.",
  "Still not reachable.": "Immer noch nicht erreichbar.",
  "Streak, {count} days in a row": "Serie, {count} Tage in Folge",
  "Streak, {count} months in a row": "Serie, {count} Monate in Folge",
  "Streak, {count} weeks in a row": "Serie, {count} Wochen in Folge",
  "Suggested": "Vorgeschlagen",
  "Suggested for “{name}”": "Vorschläge für „{name}“",
  "Tag": "Tag",
  "Tags": "Tags",
  "Take the highlighted choice": "Die markierte Wahl übernehmen",
  "Tap anywhere": "Tippe irgendwo",
  "Template": "Vorlage",
  "Templates": "Vorlagen",
  "Templates are made in the Todolix app on your iPhone, iPad or Mac: in a project that went well, ••• › Save as Template.": "Vorlagen entstehen in der Todolix-App auf deinem iPhone, iPad oder Mac: in einem Projekt, das gut lief, ••• › Als Vorlage sichern.",
  "Ten people at most can be in one.": "Höchstens zehn Personen passen hinein.",
  "That did not work. Please try again.": "Das hat nicht geklappt. Bitte versuch es noch einmal.",
  "That didn't work. Please try again.": "Das hat nicht geklappt. Bitte versuch es noch einmal.",
  "That is enough invitations for today. Try again tomorrow.": "Das reicht an Einladungen für heute. Versuch es morgen noch einmal.",
  "The area “{name}” joins your areas, with everything in it.": "Der Bereich „{name}“ kommt zu deinen Bereichen, mit allem darin.",
  "The Assistant": "Der Assistent",
  "The assistant is on your iPhone, iPad and Mac for now. It comes to the web in a later version.": "Den Assistenten gibt es vorerst auf deinem iPhone, iPad und Mac. Ins Web kommt er in einer späteren Version.",
  "The Day": "Der Tag",
  "The days since it began": "Die Tage seit dem Start",
  "The filter that takes a special size, the pool every spring, the tax return: the steps, what you need, and what went wrong last time, ready for next time.": "Der Filter in der Sondergröße, der Pool jeden Frühling, die Steuererklärung: die Schritte, was du brauchst und was letztes Mal schiefging, bereit fürs nächste Mal.",
  "The previous or next day": "Der Tag davor oder danach",
  "The same account as on your iPhone, iPad and Mac.": "Dasselbe Konto wie auf deinem iPhone, iPad und Mac.",
  "The streak goes on; the new rule counts from this month.": "Die Serie läuft weiter; die neue Regel zählt ab diesem Monat.",
  "The streak goes on; the new rule counts from this week.": "Die Serie läuft weiter; die neue Regel zählt ab dieser Woche.",
  "The streak goes on; the new rule counts from today.": "Die Serie läuft weiter; die neue Regel zählt ab heute.",
  "The template stays as it is. What you change in the project stays in the project, until you choose to keep it.": "Die Vorlage bleibt, wie sie ist. Was du im Projekt änderst, bleibt im Projekt, bis du es übernehmen willst.",
  "The web shows everything: situations hide to-dos on your iPhone, iPad and Mac, not here.": "Das Web zeigt alles: Situationen blenden To-Dos auf deinem iPhone, iPad und Mac aus, hier nicht.",
  "The Week": "Die Woche",
  "them": "den anderen",
  "third": "dritten",
  "This invitation has run out. Ask for a new one.": "Diese Einladung ist abgelaufen. Bitte um eine neue.",
  "This list": "Diese Liste",
  "this month": "diesen Monat",
  "This Month · {done} of {target}": "Dieser Monat · {done} von {target}",
  "This One": "Nur diese",
  "This share has ended.": "Das Teilen wurde beendet.",
  "This template is gone": "Diese Vorlage gibt es nicht mehr",
  "This time has passed": "Diese Uhrzeit ist vorbei",
  "This Week": "Diese Woche",
  "This week": "Diese Woche",
  "this week": "diese Woche",
  "This Week · {done} of {target}": "Diese Woche · {done} von {target}",
  "This week: {new} new, {settled} settled": "Diese Woche: {new} neu, {settled} entschieden",
  "Time": "Uhrzeit",
  "times a month": "-mal im Monat",
  "times a week": "-mal pro Woche",
  "Title": "Titel",
  "to decide": "zu entscheiden",
  "To-do deleted": "To-Do gelöscht",
  "To-Dos": "To-Dos",
  "To-dos untouched for a long time show up here.": "To-Dos, die lange niemand angefasst hat, erscheinen hier.",
  "To-dos with a deadline show up here, the most urgent first.": "To-Dos mit Deadline erscheinen hier, die dringendsten zuerst.",
  "To-dos. Beautifully done.": "To-Dos. Schön erledigt.",
  "Today": "Heute",
  "today": "heute",
  "Today (G then I Inbox, H Habits, D Deadlines, S Scheduled, A Anytime, O Someday, R Archive)": "Heute (G, dann I Inbox, H Gewohnheiten, D Deadlines, S Geplant, A Jederzeit, O Irgendwann, R Archiv)",
  "Today at a Glance": "Heute auf einen Blick",
  "Today Section": "Abschnitt in „Heute“",
  "Todolix could not be reached. Try again.": "Todolix war nicht erreichbar. Versuch es noch einmal.",
  "Todolix couldn't start. Check your connection and reload the page.": "Todolix konnte nicht starten. Prüfe deine Verbindung und lade die Seite neu.",
  "Todolix for the web, version {version}": "Todolix im Web, Version {version}",
  "Todolix Pro": "Todolix Pro",
  "Todolix {version} shows everything in your account.": "Todolix {version} zeigt alles in deinem Konto.",
  "Tomorrow": "Morgen",
  "Try a different word, or a tag with #.": "Versuch ein anderes Wort oder einen Tag mit #.",
  "Try Again": "Erneut versuchen",
  "turns {count}": "wird {count}",
  "Two Weeks": "Zwei Wochen",
  "Type": "Tippen",
  "Type a day: fri, 12.10., in 3 days": "Datum tippen: fr, 12.10., in 3 Tagen",
  "Type a time: 14:30, 3pm": "Uhrzeit tippen: 14:30, 15 Uhr",
  "Type to narrow, or a day. ↑↓ and Return choose.": "Tippen grenzt ein, oder ein Datum. ↑↓ und Return wählen.",
  "Type to narrow, or a time. ↑↓ and Return choose, ⇥ switches the tab.": "Tippen grenzt ein, oder eine Uhrzeit. ↑↓ und Return wählen, ⇥ wechselt den Tab.",
  "Type to narrow, or a time. ↑↓ and Return choose.": "Tippen grenzt ein, oder eine Uhrzeit. ↑↓ und Return wählen.",
  "Type {word} to confirm.": "Gib zur Bestätigung {word} ein.",
  "Type: 9, 14:30, 3pm": "Tippen: 9, 14:30, 15 Uhr",
  "Type: tom, fri, 12.10., in 3 days": "Tippen: mor, fr, 12.10., in 3 Tagen",
  "Undo": "Widerrufen",
  "Undone": "Widerrufen",
  "Unscheduled": "Ungeplant",
  "Until": "Bis",
  "Until {day} · streak kept": "Bis {day} · Serie gehalten",
  "Up and down inside a day": "Innerhalb eines Tages auf und ab",
  "Upcoming": "Demnächst",
  "Upcoming Deadlines": "Kommende Deadlines",
  "Update": "Aktualisieren",
  "Update Todolix to sync": "Aktualisiere Todolix, um zu synchronisieren",
  "Use": "Verwenden",
  "Use Template": "Vorlage verwenden",
  "Use {name}": "{name} verwenden",
  "View": "Ansicht",
  "Week": "Woche",
  "Week done": "Woche geschafft",
  "Weekend": "Wochenende",
  "Weekly": "Wöchentlich",
  "Weeks": "Wochen",
  "weeks in a row": "Wochen in Folge",
  "What you did stays in the history; the streak starts again, counted in days.": "Was du getan hast, bleibt im Verlauf; die Serie beginnt neu, in Tagen gezählt.",
  "What you did stays in the history; the streak starts again, counted in months, from this month.": "Was du getan hast, bleibt im Verlauf; die Serie beginnt neu, in Monaten gezählt, ab diesem Monat.",
  "What you did stays in the history; the streak starts again, counted in weeks, from this week.": "Was du getan hast, bleibt im Verlauf; die Serie beginnt neu, in Wochen gezählt, ab dieser Woche.",
  "What you do now and then, written down once.": "Was du ab und zu machst, einmal aufgeschrieben.",
  "What you do now and then, written down once: as many templates as you need. Two are free.": "Was du ab und zu machst, einmal aufgeschrieben: so viele Vorlagen, wie du brauchst. Zwei sind kostenlos.",
  "What you mean to do again and again, with its streak: as many habits as you need. Three are free.": "Was du immer wieder tun willst, mit seiner Serie: so viele Gewohnheiten, wie du brauchst. Drei sind gratis.",
  "What you mean to do again and again. Its days come into Today.": "Was du immer wieder tun willst. Seine Tage kommen in Heute.",
  "When": "Wann",
  "Which days": "Welche Tage",
  "With the To-Dos": "Bei den To-Dos",
  "Without Pro, two templates can be used and changed. This one waits, with everything in it, until Pro is back.": "Ohne Pro lassen sich zwei Vorlagen verwenden und ändern. Diese wartet mit allem, was darin steht, bis Pro zurück ist.",
  "Without streaks, the badge keeps the flame. Milestones: 7, 30, 100 and 365 days in a row (4, 12, 26 and 52 weeks).": "Ohne Serien zeigt das Abzeichen nur die Flamme. Meilensteine: 7, 30, 100 und 365 Tage in Folge (4, 12, 26 und 52 Wochen).",
  "Write It Down Once": "Einmal aufschreiben",
  "Yearly": "Jährlich",
  "Yearly On": "Am",
  "Yesterday": "Gestern",
  "Yesterday, {time}": "gestern, {time}",
  "yesterday, {time}": "gestern, {time}",
  "You didn’t tick “{title}” yesterday. Was this for yesterday or for today?": "Du hast „{title}“ gestern nicht abgehakt. War das für gestern oder für heute?",
  "You joined “{name}”": "Du bist „{name}“ beigetreten",
  "You left “{name}”": "Du hast „{name}“ verlassen",
  "You're offline. Your changes are kept and sync when you're back.": "Du bist offline. Deine Änderungen bleiben erhalten und werden synchronisiert, sobald du wieder online bist.",
  "You're online, but Todolix can't reach its server. Your changes are kept in this browser and go up as soon as it can. Some networks, like a phone's hotspot, let other apps through but not Todolix. Another network often helps.": "Du bist online, aber Todolix erreicht seinen Server nicht. Deine Änderungen bleiben in diesem Browser und werden übertragen, sobald es geht. Manche Netze, etwa ein Hotspot, lassen andere Apps durch, Todolix aber nicht. Ein anderes Netz hilft oft.",
  "Your account and everything in it go, on all your devices. A subscription is managed in the App Store.": "Dein Konto und alles darin werden auf all deinen Geräten gelöscht. Ein Abo verwaltest du im App Store.",
  "Your account holds things this version can’t show yet.": "Dein Konto enthält etwas, das diese Version noch nicht zeigen kann.",
  "Your account needs a newer version of Todolix.": "Dein Konto braucht eine neuere Version von Todolix.",
  "Your day has ended. What is left waits in the list.": "Dein Tag ist zu Ende. Was übrig ist, wartet in der Liste.",
  "Your habits for today are done, or none is due.": "Deine Gewohnheiten für heute sind erledigt, oder keine ist dran.",
  "Your sections in Today show even when nothing is left in them. When this is off, an empty section shows again once a to-do is in it.": "Deine Abschnitte in „Heute“ bleiben sichtbar, auch wenn nichts mehr darin ist. Ist das aus, erscheint ein leerer Abschnitt wieder, sobald ein To-Do darin ist.",
  "Your Whole History": "Dein ganzer Verlauf",
  "{count} completed": "{count} erledigt",
  "{count} Days": { one: "{count} Tag", other: "{count} Tage" },
  "{count} found": "{count} gefunden",
  "{count} months in a row": "{count} Monate in Folge",
  "{count} more": "{count} weitere",
  "{count} older to-dos are kept. Pro shows your whole history.": { one: "{count} älteres To-Do ist gespeichert. Pro zeigt deinen ganzen Verlauf.", other: "{count} ältere To-Dos sind gespeichert. Pro zeigt deinen ganzen Verlauf." },
  "{count} selected": "{count} ausgewählt",
  "{count} starting later": { one: "{count} beginnt später", other: "{count} beginnen später" },
  "{count} steps": { one: "{count} Schritt", other: "{count} Schritte" },
  "{count} times a month": "{count}-mal im Monat",
  "{count} times a week": "{count}-mal pro Woche",
  "{count} to decide": "{count} zu entscheiden",
  "{count} to-dos added to {list}": { one: "{count} To-Do zu {list} hinzugefügt", other: "{count} To-Dos zu {list} hinzugefügt" },
  "{count} to-dos deleted": { one: "{count} To-Do gelöscht", other: "{count} To-Dos gelöscht" },
  "{count} weeks in a row": "{count} Wochen in Folge",
  "{count}d": "{count} T.",
  "{count}d ago": "vor {count} T.",
  "{count}d left": "noch {count} T.",
  "{done} of {target} this month": "{done} von {target} diesen Monat",
  "{done} of {target} this week": "{done} von {target} diese Woche",
  "{done} of {total}": "{done} von {total}",
  "{done} of {total} done today": "{done} von {total} heute erledigt",
  "{first}–{last} of {count}": "{first}–{last} von {count}",
  "{hours} h": "{hours} Std.",
  "{hours} h {minutes}": "{hours} Std. {minutes}",
  "{items} · the oldest has waited {count} days": "{items} · das älteste wartet seit {count} Tagen",
  "{length} free": "{length} frei",
  "{length} left": "noch {length}",
  "{minutes} min": "{minutes} Min.",
  "{name} (you)": "{name} (du)",
  "{name} invites you to “{title}”": "{name} lädt dich zu „{title}“ ein",
  "{name} turns {count}": "{name} wird {count}",
  "{name}: month done": "{name}: Monat geschafft",
  "{name}: week done": "{name}: Woche geschafft",
  "{planned} of {total} planned": "{planned} von {total} geplant",
  "{steps} · last used {date}": "{steps} · zuletzt am {date}",
  "“{title}” shows in this area for you; for {name} it stays where they keep it.": "„{title}“ erscheint bei dir in diesem Bereich; bei {name} bleibt es, wo es ist.",
};
